<script lang="ts" setup>
const props = defineProps({
  link: {
    required: true,
    type: String,
  },
  slug: {
    required: true,
    type: String,
  },
});

const encodedPermalink = computed(() => encodeURIComponent(props.link));

const encodedTSlug = computed(() => encodeURIComponent(props.slug));
</script>

<template>
  <ul
    class="tw-list-none md:tw-absolute md:tw-left-0 md:tw-top-0 md:tw-w-[26px] tw-flex tw-items-center md:tw-block -tw-mb-3"
  >
    <li class="tw-mr-3 tw-mb-3">
      <a
        :href="`https://www.facebook.com/sharer/sharer.php?u=${encodedPermalink}`"
        target="_blank"
        rel="noopener noreferrer"
        class="share icon-main-facebook tw-size-[26px] tw-rounded-full tw-border tw-border-nl-green-100 tw-text-nl-green-100 tw-flex tw-items-center tw-justify-center hover:tw-text-nl-green-200 hover:tw-border-nl-green-200 tw-transition tw-duration-300 tw-ease-linear tw-mx-auto"
      ></a>
    </li>
    <li class="tw-mr-3 tw-mb-3">
      <a
        :href="`https://twitter.com/intent/tweet?url=${encodedPermalink}&text=${encodedTSlug}`"
        target="_blank"
        rel="noopener noreferrer"
        class="share icon-main-twitter tw-size-[26px] tw-rounded-full tw-border tw-border-nl-green-100 tw-text-nl-green-100 tw-flex tw-items-center tw-justify-center hover:tw-text-nl-green-200 hover:tw-border-nl-green-200 tw-transition tw-duration-300 tw-ease-linear tw-mx-auto"
      ></a>
    </li>
    <li class="tw-mr-3 tw-mb-3">
      <a
        :href="`https://www.pinterest.com/pin/create/button/?url=${encodedPermalink}&title=${encodedTSlug}`"
        target="_blank"
        rel="noopener noreferrer"
        class="share icon-main-pinterest tw-size-[26px] tw-rounded-full tw-border tw-border-nl-green-100 tw-text-nl-green-100 tw-flex tw-items-center tw-justify-center hover:tw-text-nl-green-200 hover:tw-border-nl-green-200 tw-transition tw-duration-300 tw-ease-linear tw-mx-auto"
      ></a>
    </li>
    <li class="tw-mr-3 tw-mb-3">
      <a
        :href="`mailto:?body=${link}`"
        target="_blank"
        rel="noopener noreferrer"
        class="icon-main-mail tw-size-[26px] tw-rounded-full tw-border tw-border-nl-green-100 tw-text-nl-green-100 tw-flex tw-items-center tw-justify-center hover:tw-text-nl-green-200 hover:tw-border-nl-green-200 tw-transition tw-duration-300 tw-ease-linear tw-mx-auto"
      ></a>
    </li>
  </ul>
</template>
